var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttempt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 124,
    viewBox: "0 0 155 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.75 77.5C51.5908 77.5 62 67.0908 62 54.25C62 41.4092 51.5908 31 38.75 31C25.6961 31 15.5 41.1961 15.5 54.25C15.5 67.0859 25.6961 77.5 38.75 77.5ZM46.5 85.25H31C13.8798 85.25 0 99.1298 0 116.25C0 120.529 3.47055 124 7.75 124H69.75C74.0294 124 77.5 120.529 77.5 116.25C77.5 99.1273 63.6227 85.25 46.5 85.25ZM54.25 15.5V27.5634C63.4773 32.9375 69.75 42.8188 69.75 54.25C69.75 64.3759 64.8723 73.1648 57.3403 79.05C61.8305 80.3578 65.9234 82.5133 69.5805 85.25H92.9976V73.625C92.9976 71.4845 94.7326 69.75 96.8726 69.75H120.123C122.263 69.75 123.998 71.4845 123.998 73.625V85.25H139.498V15.5H54.25Z",
    fill: "#017EA7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.375 0H50.375C43.957 0 38.75 5.38867 38.75 12.0198V23.25C44.422 23.25 49.6727 24.8923 54.032 27.5634V15.5H139.282V85.25H69.5805C74.9255 89.2412 79.1566 94.5742 81.8739 100.75H143.365C149.793 100.75 155 95.3734 155 88.7375V12.0198C155 5.38867 149.793 0 143.375 0Z",
    fill: "#017EA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt3);
export default __webpack_public_path__ + "static/media/attempt3.31c2b8f995e37a0e51a7a8cda831097e.svg";
export { ForwardRef as ReactComponent };